import { Component, input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-terms-condition-topic',
  imports: [MatExpansionModule],
  templateUrl: './terms-condition-topic.component.html',
  styleUrl: './terms-condition-topic.component.scss',
})
export class TermsConditionTopicComponent {
  title = input.required<string>();
}
